"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _RicePaper = _interopRequireDefault(require("../components/RicePaper"));
var _LinkBehavior = _interopRequireDefault(require("../theme/LinkBehavior"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Footer = props => {
  return /*#__PURE__*/_react.default.createElement(_RicePaper.default, {
    component: "footer",
    sx: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      p: 0
    },
    elevation: 3
  }, /*#__PURE__*/_react.default.createElement(_material.BottomNavigation, {
    showLabels: true
  }, _lodash.default.map(props.actions, action => /*#__PURE__*/_react.default.createElement(_material.BottomNavigationAction, {
    key: action.href,
    label: action.label,
    icon: action.icon,
    href: action.href,
    LinkComponent: _LinkBehavior.default
  }))));
};
Footer.defaultProps = {
  actions: []
};
var _default = exports.default = Footer;